import React from 'react';
import { Link } from 'react-router-dom';
import './PresenceOnboarding.css';

export default function PresenceIntegration() {
  return (
    <div className="presence-onboarding">
      <div className="presence-onboarding__inner">
        <section className="presence-card">
          <div className="presence-card__title">Integrate JG Presence into your universe</div>
          <div className="presence-integration-grid">
            <div className="presence-integration-card">
              <div className="presence-integration-title">🌌 Galaxy Overlay (Embedded SDK)</div>
              <p>
                Presence lives inside your app&mdash;on every page, component, or experience you choose.
              </p>
              <p>
                Presence is a first-class, user-visible feature tightly coupled to your UI.
              </p>
              <p>
                Your product controls where and how presence is expressed in real time.
              </p>
              <p className="presence-integration-example">
                &ldquo;Show online state across my entire product, no matter where users navigate.&rdquo;
              </p>
            </div>
            <div className="presence-integration-card">
              <div className="presence-integration-title">🛰 JG Presence Relay (Federated Service)</div>
              <p>
                Your app sends presence signals. JG Presence Engine handles aggregation, distribution, and state logic.
              </p>
              <p>
                Presence operates as shared infrastructure, not a global UI feature.
              </p>
              <p>
                Your systems consume presence where needed without embedding it everywhere.
              </p>
              <p className="presence-integration-example">
                &ldquo;My app reports activity and connection events, but I don&rsquo;t want to manage multi-tab or idle logic.&rdquo;
              </p>
            </div>
            <div className="presence-integration-card">
              <div className="presence-integration-title">🪐 Signal Observatory (Observability / Augmentation)</div>
              <p>
                Presence is consumed as structured data for analytics, moderation, or UX decisions.
              </p>
              <p>
                Presence is treated as signal data, not interaction, and is never rendered as UI.
              </p>
              <p className="presence-integration-example">
                &ldquo;Trigger features when enough users are online or analyze engagement patterns.&rdquo;
              </p>
            </div>
          </div>
          <div className="presence-links">
            <Link to="/presence/onboarding" className="presence-link">
              Presence Test Drive
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
}
